import "./MobilePageHeader.styles.scss";
import React from "react";
import { useViewport } from "utils/hooks";
import MobilePageHeaderAction from "./components/MobilePageHeaderAction";

interface MobilePageHeaderProps {
  title?: string;
  rightAction?: any;
  leftAction?: any;
  rightIcon?: any;
  leftIcon?: any;
  rightComponent?: any;
}

const MobilePageHeader = ({
  title,
  rightAction,
  leftAction,
  rightIcon,
  leftIcon,
  rightComponent,
}: MobilePageHeaderProps) => {
  const { isMobile } = useViewport();
  if (!isMobile) {
    return null;
  }
  const dynamicJustification = () => {
    let justify = "start";
    if ((!leftAction && !rightAction) || (leftAction && !rightAction)) {
      justify = "start";
    }
    if (
      (!leftAction && rightAction) ||
      (leftAction && rightAction) ||
      (!leftAction && rightComponent)
    ) {
      justify = "space-between";
    }
    return justify;
  };
  return (
    <div
      className="mobile-page-header"
      style={{ justifyContent: `${dynamicJustification()}` }}
    >
      {leftAction && (
        <div className="mobile-page-header__left">
          <MobilePageHeaderAction onActionClick={leftAction} icon={leftIcon} />
        </div>
      )}
      <h3 className="mobile-page-header__title">{title}</h3>
      {rightAction && (
        <div className="mobile-page-header__right">
          <MobilePageHeaderAction
            onActionClick={rightAction}
            icon={rightIcon}
          />
        </div>
      )}
      {rightComponent && (
        <div className="mobile-page-header__right">{rightComponent}</div>
      )}
    </div>
  );
};

export default MobilePageHeader;
